import { enumRequired, labeled, numberRequired } from '../../util/joi';
import { schema as addressSchema } from '../address/Address.schema';
import { ownershipTypes } from '../global/OwnershipType.enum';

import { propertyTypes } from '../global/PropertyType.enum';
import { zoningOptions } from '../global/ZoningOption.enum';
import { schema as ownershipSchema } from './Ownership.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    value: numberRequired(Joi, 1).label(labeled(label, 'Value')),
    zoning: enumRequired(Joi, zoningOptions, labeled(label, 'Security Zoning')),
    propertyType: enumRequired(Joi, propertyTypes, labeled(label, 'Security Property type')),
    ownershipType: enumRequired(Joi, ownershipTypes, labeled(label, 'Security Ownership Type')),
    address: addressSchema(Joi, labeled(label, 'Security -')),
    ownership: ownershipSchema(Joi, labeled(label, 'Security -'))
  });

export default {
  schema
};
